module.exports = __webpack_public_path__ + "img/default.4a333e2b.jpg";